const xapikey = "bxbWfxfgyW6mEFAgFryny2Bum25RJksh3LQBHxrH";
export default xapikey;